$(document).ready(function () {
  setTimeout(function () {
    $('.osano-cm-window__dialog').attr('role', 'region');
    $('.osano-cm-window__dialog').removeAttr('aria-describedby');
  }, 1000);
  $(document).on('click', '.osano-click-event', function () {
    Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  });

  $(document).on('click', '.cart-main-image-popup', function () {
    $('.customizer-cart-img-loader').addClass('open');

    event.preventDefault();
    var frontImage = $(this).attr('data-imagefront');
    var backImage = $(this).attr('data-imageback');

    var b = $(this).attr('data-url');
    $('.customizer-cart-image-modal .modal-body .front-img img').attr('src', frontImage);
    $('.customizer-cart-image-modal .modal-body .back-img img').attr('src', backImage);
    $('.customizer-cart-image-modal .modal-header-right a').attr('href', b);
    $('.customizer-cart-image-modal, .customizer-cart-imagedoogma-modal').addClass('show');
    popupImageLoaded();
  });

  function popupImageLoaded() {
    var popImage = false;
    var x = 0;
    var popImageLoaded = setInterval(function () {
      var popupFrontImageLoaded = false;
      var popupBackImageLoaded = false;

      if (
        $('.customizer-cart-image-modal .front-img img').prop('complete') == true &&
        $('.customizer-cart-image-modal .front-img img').prop('naturalWidth') !== 0
      ) {
        popupFrontImageLoaded = true;
      } else {
        $('.customizer-cart-image-modal .front-img img').attr(
          'src',
          $('.customizer-cart-image-modal .front-img img').attr('src').split('?')[0] + `?v=123`
        );
        popupFrontImageLoaded = false;
      }

      if (
        $('.customizer-cart-image-modal .back-img img').prop('complete') == true &&
        $('.customizer-cart-image-modal .back-img img').prop('naturalWidth') !== 0
      ) {
        popupBackImageLoaded = true;
      } else {
        $('.customizer-cart-image-modal .back-img img').attr(
          'src',
          $('.customizer-cart-image-modal .back-img img').attr('src').split('?')[0] + `?v=123`
        );
        popupBackImageLoaded = false;
      }

      if (++x > 15) {
        if (popupFrontImageLoaded == true && popupBackImageLoaded == true) {
          $('.customizer-cart-img-loader').removeClass('open');
          clearInterval(popImageLoaded);
        }
      }
    }, 100);
  }

  $('.customizer-cart-image-modal .switch-button .cart-popup-modal-checkbox').change(function () {
    if ($(this).prop('checked') == true) {
      $('.customizer-cart-image-modal .modal-body .back-img').show();
      $('.customizer-cart-image-modal .modal-body .front-img').hide();
    } else {
      $('.customizer-cart-image-modal .modal-body .back-img').hide();
      $('.customizer-cart-image-modal .modal-body .front-img').show();
    }
  });

  $('.customizer-cart-image-modal .close, .customizer-cart-image-modal .modal-footer .btn').click(
    function () {
      $('.customizer-cart-image-modal, .customizer-cart-imagedoogma-modal').removeClass('show');
    }
  );

  $(document).on('click', '.color-swatch-change', function () {
    var a = $(this).attr('data-name');
    str = a.replace(/ /g, '');
    var b = $(this).closest('.main-top-grid').find('.cust-btns a').attr('href');
    if (b) {
      b = b.split('?')[0];

      var c = b + '?data-variant=' + str;
      $(this).closest('.main-top-grid').find('.cust-btns a').attr('href', c);
    }
  });

  $('.footer__collapsible form').on('submit', function (event) {
    var emailInput = $('#Email-{{ block.id }}');

    if (!emailInput[0].checkValidity()) {
      event.preventDefault();
      emailInput.focus();
      emailInput.attr('aria-invalid', 'true');
    }
  });

  $(document).on('click', '.add-to-cart', function () {
    const chec_cart = setTimeout(() => {
      var dialog = document.querySelector('#CartDrawer[role="dialog"]');
      var firstFocusableElement = document.querySelector('#CartDrawer[role="dialog"]');
      var lastFocusableElement = document.querySelector('#CartDrawer .checkout-button-cart');
      dialog.addEventListener('keyup', function (e) {
        if (e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableElement.focus();
        } else if (e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      });
    }, 2000);
  });

  function getFocusableElements(container) {
    return [...container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    )].filter(el => el.offsetParent !== null);
  }

  const dialog = document.getElementById('FilterDrawer');

  document.addEventListener('keydown', function (e) {
    // Only run for Tab key AND when drawer is open
    if (
      e.key !== 'Tab' ||
      !dialog ||
      !dialog.classList.contains('drawer--is-open')
    ) {
      return;
    }

    const focusables = getFocusableElements(dialog);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    // Shift + Tab (backwards)
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    }
    // Tab (forwards)
    else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });


  const navDrawer = document.getElementById('NavDrawer');

  document.addEventListener('keydown', function (e) {
  // Only run for Tab key AND when NavDrawer is open
  if (
    e.key !== 'Tab' ||
    !navDrawer ||
    !navDrawer.classList.contains('drawer--is-open')
  ) {
    return;
  }

  const focusables = getFocusableElements(navDrawer);
  if (!focusables.length) return;

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  // Shift + Tab (backwards)
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  }
  // Tab (forwards)
  else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
});


  $(document).ready(function () {
      $('.pwwp__button.pwwp__button--close').attr('aria-label', 'Close');
      $('.pwwp__button.pwwp__button--fs').attr('aria-label', 'Full screen');

      const updateZoomLabel = () => {
        const zoomBtn = $('.pwwp__button.pwwp__button--zoom');

        if ($('.pwwp').hasClass('pwwp--zoomed-in')) {
          zoomBtn.attr('aria-label', 'Zoom Out');
        } else {
          zoomBtn.attr('aria-label', 'Zoom In');
        }
      };

      updateZoomLabel();

      $(document).on('click', '.pwwp__button.pwwp__button--zoom', function () {
        setTimeout(() => {
          updateZoomLabel();
        }, 0);
      });
    });
});